<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-top-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-border-anchor-link="false"
                                 :has-movie-title="false"
                                 youtube-url="https://youtube.com/shorts/ggOxpKGUp4k"
    >

        <template v-if="isXRInformationDisclosure" v-slot:content-campaign>
            <img :src="buildImgUrl('title_information.png')" alt="information" class="information" data-jest="title-information">
            <a @click="transitionPage('https://sp.pictlink.com/sp/puri_news?utm_source=meidy&utm_medium=qr&utm_campaign=owv#/17772', 'まるでリアル体験！OWVのXRプリが登場！', '_blank')"
               data-jest="btn-xr" class="btn-xr">
                <img :src="buildImgUrl('btn_xr.png')" alt="まるでリアル体験！OWVのXRプリが登場！">
            </a>
        </template>
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('img_feature_summary.png')" alt="Meidyの基本情報">
        </template>
        <template v-slot:content-1>
            <div class="cont-01">
                <img class="img-01" :src="buildImgUrl('img_contents01.png')" alt="「自分らしさを残したい」でも「ちゃんと盛りたい」を両方叶える新しい写り 自分らしさが残る、自然な仕上がりだから…SNSに載せやすい♡ 友達だけじゃなく、カップルでの撮影にもオススメ！自然な写りだと、後加工もしやすい">
            </div>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <img class="img-01" :src="buildImgUrl('img_contents02.png')" alt="全部で9枚撮影！4つの中から2つの画角を選んで撮影できるよ！定番のアップ、全身撮影に加えて…New!「超アップ」と「引き」撮影が新登場！ 自分のSNSの雰囲気に合わせて撮影画角を選べるからプリが馴染みやすくアップしやすいよ！">
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <img class="img-01" :src="buildImgUrl('img_contents03_01.png')" alt="もう焦ってスマホで落書きを探さなくて大丈夫！ 落書き中、常に表示されているから見ながら落書きできるよ♡">
                <img class="img-02" :src="buildImgUrl('img_contents03_02.png')" alt="らくがき見本は全部で21種類♡ 一発落書きとしてデザインをそのまま使うこともできるよ！さらに…今までのプリよりも落書き時間が長めだから思う存分、落書きできちゃう！(※2025年7月時点当社比)">
            </div>
        </template>
        <template v-slot:content-4>
            <div class="cont-04">
                <img class="img-01" :src="buildImgUrl('img_contents04_01.png')" alt="背景色の濃さをバーで調整できるからもっと、自分好みの特別なプリに仕上がるよ♡">
                <img class="img-01-01" :src="buildImgUrl('img_contents04_01_01.gif')" alt="こんな風に調整できるよ Pink">
                <img class="img-01-02" :src="buildImgUrl('img_contents04_01_02.gif')" alt="Black">
                <img class="img-01-03" :src="buildImgUrl('img_contents04_01_03.gif')" alt="Blue">
                <img class="img-02" :src="buildImgUrl('img_contents04_02.png')" alt="服装に合わせたり、推し活にもぴったり 落書きと組み合わせて使っても可愛いよ アスキーアート×絵文字スタンプ らくがき見本×イベントスタンプ">
            </div>
        </template>
        <template v-slot:content-5>
            <div class="cont-05">
                <img class="img-01" :src="buildImgUrl('img_contents05.png')" alt="ピクトリンク会員なら全員無料で4枚もらえちゃう 自分で配置・後加工しなくて良いから、すぐにSNS投稿できるよ！ 自分のSNSの雰囲気に合わせて使ってみてね♡">
                <img class="img-01-01" :src="buildImgUrl('img_contents05_01.gif')" alt="選べる好きなデザイン2種 デザインは全22種類! ＋">
                <img class="img-01-02" :src="buildImgUrl('img_contents05_02.gif')" alt="アレンジしやすいシンプルデザイン2種 必ずもらえる!">
            </div>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions, mapGetters} from "vuex";
import {getClickAllEvent} from "../../../util/Ga4EventUtil";

export default {
    name: "MachinePiemo2",
    components: {LayoutMachineIntroduction},
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    computed: {
        ...mapGetters({
            accountStatus: 'AccountStoreV2/accountStatus'
        }),
        machineId() {
            return 165;
        },
        sectionTitleList() {
            return [
                '01 SNSにアップしやすい♡ 別人すぎない自然で可愛い写り',
                '02 見せたい自分の雰囲気に合わせて選べる 新・画角選択',
                '03 SNSにアップしたくなるような落書きができる らくがき見本',
                '04 自分好みの背景カラーが作れる 背景濃淡調整',
                '05 撮ったプリを簡単に可愛くSNSにアップできる 9:16コラージュ',
            ];
        },
        /**
         * XR機能が情報公開されているか
         */
        isXRInformationDisclosure() {
            return this.accountStatus && this.accountStatus.timeTripDate.isInTime("2026-10-15T11:00:00", "2027-01-18T00:00:00")
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        /**
         * GA4イベントを送信してから指定したページに遷移させる
         * @param {string} url elementUrl
         * @param {string} elementText elementText
         * @param {string} transitionTarget 別窓指定
         */
        transitionPage(url, elementText, transitionTarget) {
            getClickAllEvent(url, elementText)
            window.open(url, transitionTarget)
        },
    }
}
</script>

<style scoped lang="scss">
@use "sass:math";
@use "../../../../scss/v2/base/variables";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .visual-main{
                position: relative;
                padding-bottom: variables.$grid-consistent * 2;

                .btn-shop-list {
                    position: absolute;
                    top: math.percentage(math.div(616px, $deviceWidth));
                    left: 0;
                    width: 100%;

                    &-link {
                        width: math.percentage(math.div(530px, $deviceWidth));
                    }
                }
            }
            .content-campaign {
                .information {
                    margin: auto;
                    width: math.percentage(math.div(444px, $deviceWidth));
                    padding-bottom: variables.$grid-consistent;
                }
                .btn-xr {
                    margin: auto;
                    display: block;
                    width: math.percentage(math.div(538px, $deviceWidth));
                }
            }

            .list-anchor-link {
                padding-top: variables.$grid-consistent;

                .img-link {
                    width: math.percentage(math.div(594px, $deviceWidth));
                }

                .img-line {
                    width: math.percentage(math.div(594px, $deviceWidth));
                    display: block;
                    margin: auto;
                }
            }

            .feature-summary {
                width: math.percentage(math.div(594px, $deviceWidth));
                margin: auto;
            }
        }

        &-contents {
            .accordion-inner {
                .img-01, .img-01-01, .img-01-02, .img-01-03, .img-02 {
                    display: block;
                }

                .cont-04 {
                    position: relative;
                    .img-01-01 {
                        position: absolute;
                        top: math.percentage(math.div(46px, $deviceWidth));
                        left: 0;
                    }
                    .img-01-02 {
                        position: absolute;
                        top: math.percentage(math.div(190px, $deviceWidth));
                        left: 0
                    }
                    .img-01-03 {
                        position: absolute;
                        top: math.percentage(math.div(324px, $deviceWidth));
                        left: 0
                    }
                }

                .cont-05 {
                    position: relative;
                    .img-01-01 {
                        position: absolute;
                        top: math.percentage(math.div(76px, $deviceWidth));
                        left: 0;
                    }
                    .img-01-02 {
                        position: absolute;
                        top: math.percentage(math.div(406px, $deviceWidth));
                        left: 0
                    }
                }
            }
        }

        &-movie {
            padding: math.percentage(math.div(340px, $deviceWidth)) 0 math.percentage(math.div(70px, $deviceWidth));
            background-image: v-bind("buildStyleImgUrl('movie_back.png')");
            background-size: cover;

            &-thumb {
                width: math.percentage(math.div(704px, $deviceWidth));
                margin: 0 auto math.percentage(math.div(110px, $deviceWidth));
            }
            &-btn-studio {
                width: math.percentage(math.div(450px, $deviceWidth));
                margin: 0 auto;
                box-shadow: 0 0 8px rgba(255, 255, 255, .3);
            }
        }
    }
}

</style>
